// TODO Fix on the pipeline TS
// export enum DiscussionStatus {
//   'SCHEDULED' = 'SCHEDULED',
//   'LIVE' = 'LIVE',
//   'CANCELED' = 'CANCELED',
//   'CLOSED' = 'CLOSED',
//   'OPEN' = 'OPEN',
// }
// type DiscussionStatusLabel = {
//   [key in DiscussionStatus]: string;
// };
// export const DISCUSSION_STATUS_LABEL: DiscussionStatusLabel = {

export const DiscussionStatus = {
  SCHEDULED: 'SCHEDULED',
  LIVE: 'LIVE',
  CANCELED: 'CANCELED',
  CLOSED: 'CLOSED',
  OPEN: 'OPEN',
};
export const DISCUSSION_STATUS_LABEL = {
  SCHEDULED: 'Scheduled',
  LIVE: 'Live',
  CANCELED: 'Canceled',
  CLOSED: 'Closed',
  OPEN: 'Open',
};
